import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjetoSituacao } from '../../../models/projeto-situacao.model';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ActivatedRoute } from '@angular/router';
import { ProjetoSituacaoService } from '../../../services/projeto-situacao.service';

@Component({
  selector: 'app-projeto-situacao-list',
  templateUrl: './projeto-situacao-list.component.html',
  styleUrls: ['./projeto-situacao-list.component.scss'],
})
export class ProjetoSituacaoListComponent
  extends BaseListComponent<ProjetoSituacao>
  implements OnInit, OnDestroy
{
  situacaoList: ProjetoSituacao[];

  constructor(
    private myService: ProjetoSituacaoService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.situacaoList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/pre-projeto/admin/projeto-situacao/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/admin/projeto-situacao/', id];
  }
}
